import { useState } from "react";
import { motion } from "framer-motion";
import { ZoomIn } from "lucide-react";
import { FALLBACK, pick } from "@/lib/gallery";
import Lightbox from "@/components/landing/Lightbox";

const heights = ["h-72", "h-96", "h-80", "h-64", "h-96", "h-72", "h-80", "h-64"];

export default function Gallery({ gallery }) {
  const items = (gallery && gallery.length === 8 ? gallery : FALLBACK.galeri).map((it, i) => ({
    src: pick(it?.image, FALLBACK.galeri[i]?.image),
    caption: (it?.caption || "").trim(),
  }));
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <section id="galeri" className="relative bg-parchment py-24 md:py-32" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="text-xs tracking-[0.4em] uppercase text-gold"
            >
              Galeri
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="mt-4 font-serif-display text-forest text-4xl md:text-5xl lg:text-6xl leading-[1.1]"
            >
              Momen di balik<br />
              <span className="italic text-gold">setiap halaman hafalan.</span>
            </motion.h2>
          </div>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-4 gap-6 space-y-6">
          {items.map((item, i) => (
            <motion.button
              key={i}
              type="button"
              onClick={() => setOpenIndex(i)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
              className={`relative overflow-hidden rounded-xl border border-gold/30 group break-inside-avoid ${heights[i % heights.length]} w-full block cursor-zoom-in focus:outline-none focus:ring-2 focus:ring-gold`}
              data-testid={`gallery-item-${i}`}
              aria-label={item.caption || `Buka gambar ${i + 1}`}
            >
              <img
                src={item.src}
                alt={item.caption || `Kegiatan santri ${i + 1}`}
                className="absolute inset-0 w-full h-full object-cover img-warm transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-forest/0 group-hover:bg-forest/40 transition-colors duration-500" />
              <span className="absolute top-3 right-3 inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/85 text-forest opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <ZoomIn size={16} />
              </span>
              {item.caption && (
                <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-forest/85 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 text-left">
                  <p className="text-parchment text-sm font-serif-display leading-snug">{item.caption}</p>
                </div>
              )}
            </motion.button>
          ))}
        </div>
      </div>

      <Lightbox
        items={items}
        index={openIndex}
        onClose={() => setOpenIndex(-1)}
        onChange={setOpenIndex}
        testIdPrefix="lightbox"
      />
    </section>
  );
}
